import { render, staticRenderFns } from "./quotationManage.vue?vue&type=template&id=12a5ad4e&scoped=true"
import script from "./quotationManage.vue?vue&type=script&lang=js"
export * from "./quotationManage.vue?vue&type=script&lang=js"
import style0 from "./quotationManage.vue?vue&type=style&index=0&id=12a5ad4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5ad4e",
  null
  
)

export default component.exports